module.exports = __webpack_public_path__ + "static/media/erich.6cfeb9ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/erich.jpg
// module id = 120
// module chunks = 0